import { render } from "./AdminNotesTable.vue?vue&type=template&id=3e29aed9"
import script from "./AdminNotesTable.vue?vue&type=script&lang=js"
export * from "./AdminNotesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__